import { render, staticRenderFns } from "./SignUpPageCompany.vue?vue&type=template&id=2f672d04&"
import script from "./SignUpPageCompany.vue?vue&type=script&lang=js&"
export * from "./SignUpPageCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports